import { useMemo } from 'react';
import { Button, Spinner } from '@/components/generic';
import { copyToClipboard } from '@/utils';
import { useChainStore, useMagic } from '@package/smart-wallet';
import {
  bitcoinChain,
  SUPPORTED_CHAINS,
} from '@package/smart-wallet/constants';
import { useGetDepositInfo } from '@package/smart-wallet/hooks';
import QrSvg from '@wojtekmaj/react-qr-svg';

const QrCode = () => {
  const { bitcoin } = useMagic();
  const chainId = useChainStore((state) => state.chainId);
  const { depositAddress, isLoading } = useGetDepositInfo();
  const isBtcChain = chainId === bitcoinChain.id;

  const address = useMemo(
    () => (isBtcChain ? bitcoin.address : depositAddress) || '',
    [isBtcChain, bitcoin.address, depositAddress],
  );

  return (
    <>
      <div className='mb-1 py-6 text-center max-md:pt-0 '>
        <div className='flex justify-center items-center '>
          <div className='w-32 h-32'>
            {isLoading ? (
              <Spinner className='w-32 h-32' />
            ) : (
              <QrSvg value={address} />
            )}
          </div>
        </div>
        <div className='mt-1 text-body-2 text-t-secondary'>
          <span className='text-primary-02'>{address}</span>
        </div>
      </div>
      <div className='mb-4'>
        <h3 className='text-sm font-semibold text-t-secondary mb-3'>
          Supported Networks
        </h3>
        <div className='flex flex-wrap gap-3 justify-center'>
          {Object.values(SUPPORTED_CHAINS)
            .filter((chain) =>
              isBtcChain
                ? chain.chain.id === bitcoinChain.id
                : chain.chain.id !== bitcoinChain.id,
            )
            .map((chain) => (
              <div
                key={chain.chain.id}
                className='flex items-center gap-2 px-4 py-2 rounded-lg bg-b-surface2 border border-s-subtle'
              >
                <img
                  src={chain.icon}
                  alt={chain.chain.name}
                  className='w-6 h-6 rounded-full'
                />
                <span className='text-sm text-t-primary'>
                  {chain.chain.name}
                </span>
              </div>
            ))}
        </div>
      </div>

      <div className='mb-4 p-4 rounded-lg bg-yellow-500/10 border border-yellow-500/30'>
        <div className='flex items-start gap-2'>
          <svg
            className='w-5 h-5 text-yellow-500 shrink-0 mt-0.5'
            fill='currentColor'
            viewBox='0 0 20 20'
          >
            <path
              fillRule='evenodd'
              d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z'
              clipRule='evenodd'
            />
          </svg>
          <div className='text-sm'>
            <p className='font-semibold text-yellow-500 mb-1'>
              Important Notice
            </p>
            <p className='text-t-secondary'>
              Deposits and card creation are currently only available for USDT
              token on the{' '}
              <span className='font-semibold text-t-primary'>
                Binance Smart Chain (BSC)
              </span>{' '}
              network.
            </p>
          </div>
        </div>
      </div>

      <Button
        className='w-full'
        onClick={() => copyToClipboard(address)}
        isBlack
      >
        Copy Address
      </Button>
    </>
  );
};

export default QrCode;
